export default {
  data() {
    return {
      fields: [],
    };
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type !== 'grid/setState') {
        return;
      }
      // rollback filters
      for (const slug of Object.keys(state.grid.filters)) {
        let field = this.fields.find(f => f.slug === slug);
        if (field) {
          field.setValue(state.grid.filters[slug]);
        }
      }
    });

    this.$root.$on('field.changed', field => {
      this.$store.commit('grid/addFilter', {column: field.slug, value: field.getValue()});
    });
  },
  methods: {
    registerField(field) {
      this.fields.push(field);
    }
  },
  provide: function () {
    return {
      register: this.registerField,
    };
  },
}



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/assets/js/theme-mixins/DataGridFilters.js